import {
  useModalContext,
  useWSSnackbar,
  WSButton,
  WSForm,
  WSModal,
  WSText
} from "@wingspanhq/fe-component-library";
import React, { useLayoutEffect, useMemo, useState } from "react";
import { useWSStore } from "../../store";
import { vgVaultKey } from "../components/BankCard/BankCard";

import styles from "./ChangePin.module.scss";
import { WSErrorMessage } from "../../components/WSErrorMessage/WSErrorMessage";
import { ErrorContextKey } from "../../services/platform";
import { useCardQuery } from "../../query/payments/queries";

export const CHANGE_PIN_MODAL = "CHANGE_PIN_MODAL";

const Inner: React.FC<{ cardId: string }> = props => {
  const { closeModal } = useModalContext();
  const { openSnackbar } = useWSSnackbar();

  const cardQuery = useCardQuery(props.cardId);

  const [loading, setLoading] = useState<any>(null);
  const [error, setError] = useState<any>(null);
  const [formState, setFormState] = useState<any>(null);

  const validationError = !!(
    formState?.["data.attributes.newPin"]?.errorMessages?.length ||
    formState?.["data.attributes.oldPin"]?.errorMessages?.length
  );

  const {
    bankCardTokens: { token, ids }
  } = useWSStore();

  const cardID = ids[props.cardId];

  const form = useMemo(() => {
    return window.VGSCollect.create(
      vgVaultKey,
      process.env.REACT_APP_ENV === "production" ? "live" : "sandbox",
      setFormState
    );
  }, []);

  useLayoutEffect(() => {
    if (window.document.querySelector("#cc-old-pin iframe")) {
      return;
    }

    form.field("#cc-old-pin", {
      type: "text",
      name: "data.attributes.oldPin",
      successColor: "#282d37",
      errorColor: "#c52e24",
      placeholder: "1234",
      maxLength: 6,
      validations: ["required", "/^([0-9]{4,6})$/"]
    });
    form.field("#cc-new-pin", {
      type: "text",
      name: "data.attributes.newPin",
      successColor: "#282d37",
      errorColor: "#c52e24",
      placeholder: "1234",
      maxLength: 6,
      validations: ["required", "/^([0-9]{4,6})$/"]
    });
  }, []);

  return (
    <>
      <WSText.Heading3 mb="M">Change PIN</WSText.Heading3>
      <WSForm
        id="cc-form"
        onSubmit={() => {
          if (validationError) {
            return;
          }

          setLoading(true);
          form.submit(
            `/cards/${cardID}/secure-data/pin`,
            {
              method: "PUT",
              mapDotToObject: "true",
              headers: {
                "Content-Type": "application/vnd.api+json",
                Authorization: "Bearer " + token
              }
            },
            async (status: any, other: any) => {
              if (status === 200) {
                await cardQuery.refetch();
                setLoading(false);
                closeModal(CHANGE_PIN_MODAL);
                openSnackbar({
                  type: "success",
                  message: "Pin successfully changed!"
                });
              } else {
                setError(
                  other?.errors[0]?.title?.includes("Incorrect")
                    ? "Existing PIN is incorrect"
                    : "Something went wrong"
                );
                setLoading(false);
              }
            }
          );
        }}
      >
        <WSForm.Label mt="M">Existing PIN</WSForm.Label>
        <span id="cc-old-pin" className={styles.input}></span>

        <WSForm.Label mt="M">New PIN</WSForm.Label>
        <span id="cc-new-pin" className={styles.input}></span>

        <WSErrorMessage
          mt="M"
          error={error}
          contextKey={ErrorContextKey.Other}
        />

        <WSButton.Primary
          disabled={validationError}
          loading={loading}
          fullWidth
          mt="M"
          type="submit"
        >
          Confirm
        </WSButton.Primary>
      </WSForm>
    </>
  );
};

export const ChangePin: React.FC<{ cardId: string }> = props => {
  const { closeModal } = useModalContext();

  return (
    <WSModal
      name={CHANGE_PIN_MODAL}
      size="S"
      onClose={() => closeModal(CHANGE_PIN_MODAL)}
    >
      <Inner cardId={props.cardId} />
    </WSModal>
  );
};
